import axios from 'axios';
import { ProjectRegistration, ProjectRegistrationStorePayload } from '@resources/scripts/models';

export const getPaged = ({
 page, pageSize, sortField, sortOrder, status, filter,
}) => {
  const params = [`sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`, `status=${status}`, `filter=${filter}`].join('&');
  return axios.get(`/api/admin/projectregistrations/paged?${params}`);
};
export const create = (payload: ProjectRegistrationStorePayload) => axios.post('/api/projectregistrations', payload);
export const update = (id: number, registration: ProjectRegistrationStorePayload) => axios.patch(`/api/projectregistrations/${id}`, registration);
export const submitFinal = (id: number, registration: ProjectRegistrationStorePayload) => axios.post(`/api/projectregistrations/${id}/submit`, registration);
export const getById = (id: number) => axios.get(`/api/admin/projectregistrations/${id}`);
export const updateAdmin = (id: number, registration: ProjectRegistration) => axios.patch(`/api/admin/projectregistrations/${id}`, registration);
export const sendApprovedEmail = (id: number, projectNumber: string) => axios.post(`/api/admin/projectregistrations/${id}/send-approval-email?projectNumber=${projectNumber}`);

export default {
  create,
  getById,
  update,
  submitFinal,
  updateAdmin,
  sendApprovedEmail,
};